/**
 * Plug type diagrams from public/images/plugs (WebP from iOS Assets).
 * iOS uses Image("Type \(plugType)") for letters A–N.
 */

const PLUGS_BASE = '/images/plugs';

const PLUG_TYPES = new Set([
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
]);

/** Resolve a plug type letter (e.g. "A", "n") to a public WebP URL, or null. */
export function plugTypeImageUrl(plugType: string): string | null {
  const letter = plugType.trim().toUpperCase();
  if (!PLUG_TYPES.has(letter)) return null;
  return `${PLUGS_BASE}/${encodeURIComponent(`Type ${letter}`)}.webp`;
}
